import Jumbotron from './Jumbotron';
import React, { useState } from 'react';

const images = [
  "http://i1043.photobucket.com/albums/b434/drebrahimi/test1.jpg",
  "http://i1043.photobucket.com/albums/b434/drebrahimi/test2.jpg",
  "http://i1043.photobucket.com/albums/b434/drebrahimi/test3.jpg",
  "http://i1043.photobucket.com/albums/b434/drebrahimi/test4.jpg",
  "http://i1043.photobucket.com/albums/b434/drebrahimi/test5.jpg",
  "http://i1043.photobucket.com/albums/b434/drebrahimi/test6.jpg",
  "http://i1043.photobucket.com/albums/b434/drebrahimi/test7.jpg",
  "http://i1043.photobucket.com/albums/b434/drebrahimi/test8.jpg"
];
const thumbnails = [
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/Thumbnails/96mthumbccbeca72-1983-4ec8-bae6-8992ca8fee1e.jpg",
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/Thumbnails/96mthumb36d0a62b-9214-4e99-a25b-6a003a0ca81e.jpg",
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/Thumbnails/96mthumb02474951-e237-4467-8b66-d461648076ac.jpg",
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/Thumbnails/96mthumbbfaa253f-210a-4744-9687-195f84f86a90.jpg",
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/Thumbnails/96mthumb2ceed4d6-d911-4669-9a90-9d48e9136034.jpg",
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/Thumbnails/96mthumbb71537c1-222d-49ba-ad38-da083d728334.jpg",
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/Thumbnails/96mthumb1d6a0857-64f1-4107-811c-3a403319f689.jpg"
];

const fullSizeImages = [
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/WebImages/96mwebd36a3df2-beb4-4a88-b224-6a680a8086b2.jpg",
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/WebImages/96mwebf300f326-a90d-4c36-be6c-c7b39e98d995.jpg",
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/WebImages/96mweb46852891-f045-4844-a540-ea7bfa9ade25.jpg",
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/WebImages/96mwebe05633da-9f63-475b-8461-61b8abd8a41c.jpg",
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/WebImages/96mweb01324d75-2980-448e-b96f-428a37c0c2d1.jpg",
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/WebImages/96mweb42b876a2-afd3-4904-a394-0cbdd82a8f7b.jpg",
  "http://drebrahimi.com/Data/Sites/1/GalleryImages/96/WebImages/96mwebf6c0af98-3d06-44dd-92d5-1bd6f71b8bfc.jpg"
];
const Oop = () => {
  const [selectedImage, setSelectedImage] = useState(fullSizeImages[0]);

  return (
    <>
      <Jumbotron />
      <div className="page-padd mt-4">
        <div className="accordion" id="accordionExample">
          <div className="card">
            <div className="card-header p-0" id="headingOne">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  State University of New York- Empire State College
                </button>
              </h2>
            </div>

            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div className="card-body">
                <h5>State University of New York- Empire State College</h5>
                <p>Link to Dr. Ebrahimi's lessons decribing helpful tips to start C++ Programming:.</p>
                <div className="text-center mt-3">
                  <a href="https://www.youtube.com/programmingeasyways" target="_blank" className="btn btn-primary text-white">www.youtube.com/programmingeasyways</a>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingTest">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTest" aria-expanded="false" aria-controls="collapseTest">
                  Test Data
                </button>
              </h2>
            </div>
            <div id="collapseTest" className="collapse" aria-labelledby="headingTest" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Testing a Data File</h5>
                <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                  <p>
                    Hello and I hope you are doing well. Module 2 assignments are very interesting where you start to see the power of programming, which will be a great experience for you. Please try to experiment with them yourself as much as you can, as it’s a great way to understand databases and even Google.
                  </p>
                  <p>There are two ways to approach this, and I prefer the first one at this time:</p>
                  <ol>
                    <li>
                      By redirection "<code>&lt;</code>" in the cmd mode: <code>c:\my documents\testdatafile.exe &lt; testdatafile.in</code>
                    </li>
                  </ol>
                  <p>Please refer to the end of Chapter 3 on the topic of DOS or UNIX commands.</p>
                  <p>
                    Alternatively, you can use file streaming within the program. Please refer to Question Q3e at the end of Chapter 3. Chapter 9 is dedicated to file handling for this purpose.
                  </p>
                  <p>az
                    The easiest way to link your executed program to a data file is by using the command mode and redirection. Here’s how to use a data file in your program:
                  </p>
                  <ol>
                    <li>Type the program interactively and save it as <code>testdatafile.cpp</code>. Test your program for correctness by entering the data interactively.</li>
                    <li>Create a data file by selecting <strong>New &gt; File &gt; Resource</strong> and naming it <code>testdatafile.in</code>.</li>
                  </ol>

                  <div className="row">
                    {images.map((image, index) => (
                      <div className="col-md-6 mb-4" key={index}>
                        <img src={image} alt={`Module 2 Image ${index + 1}`} className="img-fluid" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingTwo">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Module One
                </button>
              </h2>
            </div>
            <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Assignment 1</h5>
                <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                  <div>
                    <p><strong>Module Overview:</strong></p>
                  </div>

                  <p>
                    <strong>This module provides a general overview of the fundamentals of programming and demonstrates how to write a small program with input, process, and output.</strong>
                  </p>

                  <p><strong>Module Learning Objectives:</strong></p>
                  <ul>
                    <li>Basic concepts of Programming and Object-Oriented Programming (OOP)</li>
                    <li>Introduction to C++ programming</li>
                    <li>C++ Examples</li>
                  </ul>

                  <p><strong>Readings:</strong></p>
                  <p>Chapter 1<br />Chapter 2</p>

                  <p><strong>Assignments:</strong></p>
                  <p><strong>During this week:</strong></p>
                  <ul>
                    <li>Create your profile (go to the Preferences setting in the left-hand navigation bar)</li>
                    <li>Read the profiles of others in the course (go to the Roster on the Communicate tab)</li>
                    <li>Ensure you have all of the course materials</li>
                    <li>Verify that the required version of C++ is properly installed</li>
                  </ul>
                  <p>Complete all the assignments in the assignment area.</p>

                  <p><strong>Discussions:</strong></p>
                  <p>
                    <strong>Start Date:</strong> Week 1<br />
                    <strong>End Date:</strong> End of Week 2
                  </p>
                  <ul>
                    <li>Start Discussion</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingThree">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Module Two
                </button>
              </h2>
            </div>
            <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Assignment 2</h5>
                <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                  <div>
                    <p>
                      <strong>Module Overview:</strong><br />
                      This module introduces students to the concepts of Loops and Decision Making.
                    </p>
                    <p><strong>Module Learning Objectives:</strong></p>
                  </div>

                  <ul>
                    <li>Concept of loop and use of repetition</li>
                    <li>Variation in use of loop statement (while loop)</li>
                    <li>Infinite loop</li>
                    <li>Reading data from a file</li>
                    <li>Nested loop</li>
                    <li>Decision making and if statement</li>
                    <li>Nested if</li>
                    <li>Logical Operator</li>
                    <li>Error checking</li>
                    <li>Problem solving techniques</li>
                  </ul>

                  <p>
                    <strong>Readings</strong><br />
                    Chapter 3<br />
                    Chapter 4
                  </p>

                  <p>
                    <strong>Assignments:</strong><br />
                    Complete all the assignments in the assignment area.
                  </p>

                  <p>
                    <strong>Discussions:</strong><br />
                    <strong>Start Date:</strong> Week 3<br />
                    <strong>End Date:</strong> End of Week 4
                  </p>

                  <ul>
                    <li>Start Discussion on what is OOP and its significance</li>
                  </ul>

                  <p>
                    <strong><em>If you have any questions about the assignments or activities for this module, please click on the ASK A QUESTION link at the top of this page. Now go to the next document to begin this module.</em></strong>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header p-0" id="headingFour">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                  Module Three
                </button>
              </h2>
            </div>

            <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Assignment 3</h5>
                <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                  <div>
                    <p>
                      <strong>Module Overview:</strong><br />
                      This module introduces students to the concepts of Arrays and Functions.
                    </p>
                    <p><strong>Module Learning Objectives:</strong></p>
                  </div>

                  <ul>
                    <li>Creating and accessing arrays</li>
                    <li>Two-dimensional arrays</li>
                    <li>Use arrays for tabular formatting</li>
                    <li>Introduction to functions</li>
                  </ul>

                  <p><strong>Readings:</strong></p>
                  <p>
                    Chapter 5<br />
                    Chapter 6
                  </p>

                  <p>
                    <strong>Assignments:</strong><br />
                    Complete all the assignments in the assignment area.
                  </p>

                  <p>
                    <strong>Discussions:</strong><br />
                    <strong>Start Date:</strong> Week 5<br />
                    <strong>End Date:</strong> Week 6
                  </p>

                  <ul>
                    <li>Discussion</li>
                  </ul>

                  <p>
                    <strong><em>If you have any questions about the assignments or activities for this module, please click on ASK A QUESTION at the top of this page. Now go to the next document to begin this module.</em></strong> Updated 10/23/2018
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingFive">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                  Module Four
                </button>
              </h2>
            </div>

            <div id="collapseFive" className="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Assignment 4</h5>
                <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                  <div>
                    <p>
                      <strong>Module Overview:</strong><br />
                      This module builds on the topic of functions and introduces the concepts of pointers.
                    </p>
                    <p><strong>Module Learning Objectives:</strong></p>
                  </div>

                  <ul>
                    <li>Function declaration</li>
                    <li>Function definition</li>
                    <li>Pass by value</li>
                    <li>Pass by reference</li>
                    <li>Local and Global variables</li>
                    <li>Pointer declaration</li>
                    <li>Dynamic memory allocation</li>
                    <li>Addressing and dereferencing</li>
                  </ul>

                  <p><strong>Readings:</strong></p>
                  <p>
                    Chapter 6<br />
                    Chapter 13
                  </p>

                  <p><strong>Tasks:</strong></p>
                  <p>
                    Complete Quiz 2<br />
                    Complete Midterm project<br />
                    Participate in Discussion
                  </p>

                  <p><strong>Discussions:</strong></p>
                  <p>
                    <strong>Start Date:</strong> Week 7<br />
                    <strong>End Date:</strong> Week 8
                  </p>

                  <p>
                    <strong><em>If you have any questions about the assignments or activities for this module, please click on the ASK A QUESTION link at the top of this page. Now go to the next document to begin this module.</em></strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingSix">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                  Module Five
                </button>
              </h2>
            </div>

            <div id="collapseSix" className="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Assignment 5</h5>
                <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                  <div>
                    <p>
                      <strong>Module Overview:</strong><br />
                      This module introduces the concept of classes.
                    </p>
                    <p><strong>Module Learning Objectives:</strong></p>
                  </div>

                  <ul>
                    <li>Object as an instance of a class</li>
                    <li>Class scope and accessing class members</li>
                    <li>Constructors and destructors</li>
                    <li>Data abstraction and information hiding</li>
                  </ul>

                  <p><strong>Readings:</strong></p>
                  <p>Chapter 8</p>

                  <p><strong>Assignments:</strong></p>
                  <p>Complete Phase 1 of Case Study in assignment area</p>

                  <p><strong>Discussions:</strong></p>
                  <p>
                    <strong>Start Date:</strong> Week 9<br />
                    <strong>End Date:</strong> Week 10
                  </p>

                  <ul>
                    <li>Start Discussion</li>
                  </ul>

                  <p>
                    <strong><em>If you have any questions about the assignments or activities for this module, please click on the ASK A QUESTION at the top of this page. Now go to the next document to begin this module.</em></strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header p-0" id="headingSeven">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="true" aria-controls="collapseSeven">
                  Visual Studio Express
                </button>
              </h2>
            </div>

            <div id="collapseSeven" className="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Visual Studio Express</h5>
                <div id="ctl01_mainContent_ctl00_upGallery" className="slidecontainer">
      <div className="modulecontent">
        <div className="row">
          {thumbnails.map((thumbnail, index) => (
            <div className="col-md-2 mb-4" key={index}>
              <img
                src={thumbnail}
                alt={`Thumbnail ${index + 1}`}
                className="img-fluid"
                style={{ borderWidth: 0, cursor: 'pointer' }}
                onClick={() => setSelectedImage(fullSizeImages[index])} // Update selected image on click
              />
            </div>
          ))}
        </div>

        <div className="divgalleryimage text-center">
          <img src={selectedImage} alt="Selected large view" className="img-fluid" />
        </div>
      </div>
    </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-3">
          <iframe frameBorder="0" height="300" title="myFrame"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3020.3113589675813!2d-73.57774648414325!3d40.79915127932243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c286b96a1b2727%3A0xad943160e075b92f!2sNew+Academic+Building+at+SUNY+Old+Westbury!5e0!3m2!1sen!2sus!4v1513701666413"
            className="iframeStyle">
          </iframe>
        </div>
      </div>
    </>
  );
}

export default Oop;